import { SET_MODAL_STACK, OPEN_MODAL } from 'aria-viewer/modal/modalActions'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants/mobileAnalytics'
import { getTourData, getMobileDefaultProperties } from 'aria-viewer/analytics/utils/analyticUtils'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'
import ModalTypes from 'aria-viewer/modal/constants/ModalTypes'
import { ANALYTICS_REGISTRATION_BTN_CLICKED } from 'aria-viewer/analytics/analyticActions'

const modalAnalytics = {
    [SET_MODAL_STACK]: (getState, action) => {
        const state = getState()

        const nextModal = action.modals.get(0)
        const currentModal = state.getIn(['modal', 'modalStack']).get(0)
        const isSlidePanelOpen = state.getIn(['slidePanel', 'isSlidePanelOpen'])
        let properties = getMobileDefaultProperties()(getState)
        const { stoptitle, welcomePrompt } = getTourData()(getState)

        // Determine if registration button was clicked
        if (
            nextModal &&
            nextModal.content.name == ModalContentTypes.REGISTRATION &&
            !nextModal.content.prompt &&
            !isSlidePanelOpen
        ) {
            return trackEvent(welcomePrompt ? EVENTS.M_WELREG_STARTBUTTON_TAPPED : EVENTS.M_MOBEXP_REGBUTTON_TAPPED, {
                ...properties,
                Stop: stoptitle,
            })
        } else if (
            nextModal == undefined &&
            currentModal &&
            currentModal.name == ModalTypes.ALERT &&
            currentModal.content.id == ANALYTICS_REGISTRATION_BTN_CLICKED
        ) {
            // Registration modal was completed - Ok button was clicked
            const { prompt } = currentModal.content

            const event = prompt
                ? EVENTS.M_SKIPSTOPREG_OKBUTTON_TAPPED
                : welcomePrompt
                    ? EVENTS.M_WELREG_OKBUTTON_TAPPED
                    : EVENTS.M_DIRREG_OKBUTTON_TAPPED

            return trackEvent(event, {
                ...properties,
                Stop: stoptitle,
            })
        }
    },

    [OPEN_MODAL]: (getState, action) => {
        if (action.modal.content.type === ModalContentTypes.REGISTRATION) {
            const { inst_name, loc_name, owner_id, loc_id, stoptitle } = getTourData()(getState)

            return trackEvent(EVENTS.M_WELREG_STEP2_VIEWED, {
                Institution: inst_name,
                Location: loc_name,
                Inst_ID: owner_id,
                Loc_ID: loc_id,
                Stop: stoptitle,
            })
        }
    },
}

export default modalAnalytics
